import React, { useMemo, useCallback } from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableColText, TableHeadText } from '../../../../../components/pdf/TableHelpers'
import {
  getReplyValue,
  findReplyByQuestionName,
  filterRepliesByQuestionName,
  findReplyByReference,
  filterRepliesByParentReference,
  findParentReply,
  getJobDescription
} from '../../_helpers/pdfHelpers'
import View from '../../../../../components/pdf/View'

const PgrTable = ({ serviceOrder }) => {
  const max = useCallback(
    (sector, pergunta) => {
      let max = 0
      const noises = filterRepliesByQuestionName(serviceOrder.replies, pergunta)
      noises.forEach(noise => {
        const parent = findParentReply(serviceOrder.replies, noise)
        if (parent.question.name.includes(sector) && noise.value > max) {
          max = noise.value
        }
      })

      return max
    },
    [serviceOrder.replies]
  )

  const maxNoise = useMemo(() => {
    const customerServiceNoise = max('Atendimento', 'RUIDO - DB(A) [1]')
    const commercialNoise = max('Comercial', 'RUIDO - DB(A) [1]')
    return customerServiceNoise > commercialNoise ? customerServiceNoise : commercialNoise
  }, [max])

  const riskMap = useMemo(() => {
    const result = {}
    const replies = filterRepliesByQuestionName(
      serviceOrder.replies,
      'Há riscos físicos, químicos, biológicos, acidentes ou ergonômicos na agencia? VER LISTA ABAIXO'
    )
    replies.forEach(reply => {
      if (reply.value) {
        const funcao = findReplyByReference(serviceOrder.replies, reply.question.parentReference).question.name
        const nomeFuncao = getJobDescription(funcao).funcao
        const outrasRespostasDoMesmoPai = filterRepliesByParentReference(
          serviceOrder.replies,
          reply.question.parentReference
        )
        const totalEmployees = getReplyValue(
          findReplyByQuestionName(outrasRespostasDoMesmoPai, 'Quantos funcionários possui nesse cargo?')
        )
        reply.value.forEach(value => {
          const { name } = value
          const cleanName = name
            .replace('ACIDENTES - ', '')
            .toLowerCase()
            .replace(/^\w/, c => c.toUpperCase())
          if (!result[cleanName]) {
            result[cleanName] = []
          }

          result[cleanName].push({ totalEmployees, funcao: nomeFuncao, nomeRisco: cleanName })
        })
      }
    })

    return result
  }, [serviceOrder.replies])

  const montarControleExistencia = risco => {
    return (
      <TableRow>
        <TableColText align="center" size="13px">
          Acidentes
        </TableColText>

        <TableColText align="center" size="13px">
          {risco}
        </TableColText>

        <TableColText align="center" size="13px">
          Agência / Piso, depressões ou objetos
        </TableColText>

        <TableColText align="center" size="13px">
          Qualitativa
        </TableColText>

        <TableColText align="center" size="13px">
          Contato / Lesões pontuais e escoriações em casos mais graves torções e/ou fraturas ósseas
        </TableColText>

        <TableColText align="center" size="13px">
          N/A
        </TableColText>

        <TableColText align="center" size="13px">
          N/A
        </TableColText>

        <TableColText align="center" size="13px">
          N/A
        </TableColText>

        <TableColText align="center" size="13px">
          N/A
        </TableColText>

        <TableColText align="center" size="13px">
          N/A
        </TableColText>

        <TableColText align="center" size="13px">
          Qualitativa
        </TableColText>

        <TableColText align="center" size="13px">
          Qualitativa
        </TableColText>

        <TableColText align="center" size="13px">
          1
        </TableColText>

        <TableColText align="center" size="13px">
          1
        </TableColText>

        <TableColText align="center" size="13px">
          Baixo
        </TableColText>

        <TableColText align="center" size="13px">
          Nenhuma ação ou educação dos colaboradores através de informativos e treinamentos
        </TableColText>

        <TableColText align="center" size="13px">
          Considerações podem ser feitas para avaliar soluções mais efetivas e de menor custo ou ainda melhorias que não
          envolvem custo; Procedimentos e/ou objetivos e metas são opcionais; Registrar e informar aos trabalhadores.
        </TableColText>
      </TableRow>
    )
  }

  return (
    <View pageBreakAfter>
      <Table width="100%">
        <TableRow>
          <TableHeadText rowSpan={2} align="center" size="12px">
            Agente / Tipo
          </TableHeadText>

          <TableHeadText rowSpan={2} align="center" size="12px">
            Perigo / Fonte de Riscos
          </TableHeadText>

          <TableHeadText rowSpan={2} align="center" size="12px">
            Dano
          </TableHeadText>

          <TableHeadText rowSpan={2} align="center" size="12px">
            Padrões Legais / Limite de Exposição
          </TableHeadText>

          <TableHeadText rowSpan={2} align="center" size="12px">
            Fonte Geradora
          </TableHeadText>

          <TableHeadText colSpan={5} align="center" size="12px">
            Controle Existente e sua Eficácia
          </TableHeadText>

          <TableHeadText colSpan={2} align="center" size="12px">
            Perfil de exposição existente
          </TableHeadText>

          <TableHeadText colSpan={3} align="center" size="12px">
            Avaliação do Risco
          </TableHeadText>

          <TableHeadText rowSpan={2} align="center" size="12px">
            Definições de ações necessárias e prioridades
          </TableHeadText>

          <TableHeadText rowSpan={2} align="center" size="12px">
            Critério para monitoramento da exposição
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableHeadText align="center" size="12px">
            EPC
          </TableHeadText>

          <TableHeadText align="center" size="12px">
            Eficaz (S/N)
          </TableHeadText>

          <TableHeadText align="center" size="12px">
            EPI
          </TableHeadText>

          <TableHeadText align="center" size="12px">
            Atenuação / Fator de Proteção
          </TableHeadText>

          <TableHeadText align="center" size="12px">
            Eficaz (S/N)
          </TableHeadText>

          <TableHeadText align="center" size="12px">
            Intens. / Conc.
          </TableHeadText>

          <TableHeadText align="center" size="12px">
            Técnica Utilizada
          </TableHeadText>

          <TableHeadText align="center" size="12px">
            P
          </TableHeadText>

          <TableHeadText align="center" size="12px">
            G
          </TableHeadText>

          <TableHeadText align="center" size="12px">
            RISCO
          </TableHeadText>
        </TableRow>

        <TableRow>
          <TableColText align="center" size="12px">
            Físico
          </TableColText>

          <TableColText align="center" size="12px">
            Ruído
          </TableColText>

          <TableColText align="center" size="12px">
            Via aérea/ PAIRO - Perda auditiva induzida por ruído ocupacional
          </TableColText>

          <TableColText align="center" size="12px">
            Nível de ação: 80 dB(a) Limite de tolerância 85 dB(a)
          </TableColText>

          <TableColText align="center" size="12px">
            Ambiente administrativo/Proveniente do local de trabalho
          </TableColText>

          <TableColText align="center" size="12px">
            N/A
          </TableColText>

          <TableColText align="center" size="12px">
            N/A
          </TableColText>

          <TableColText align="center" size="12px">
            N/A
          </TableColText>

          <TableColText align="center" size="12px">
            N/A
          </TableColText>

          <TableColText align="center" size="12px">
            N/A
          </TableColText>

          <TableColText align="center" size="12px">
            {maxNoise} dB(a)
          </TableColText>

          <TableColText align="center" size="12px">
            Ruído pontual
          </TableColText>

          <TableColText align="center" size="12px">
            1
          </TableColText>

          <TableColText align="center" size="12px">
            1
          </TableColText>

          <TableColText align="center" size="12px">
            Baixo
          </TableColText>

          <TableColText align="center" size="12px">
            Nenhuma ação ou educação dos colaboradores através de informativos e treinamentos
          </TableColText>

          <TableColText align="center" size="12px">
            Considerações podem ser feitas para avaliar soluções mais efetivas e de menor custo ou ainda melhorias que
            não envolvem custo; Procedimentos e/ou objetivos e metas são opcionais; Registrar e informar aos
            trabalhadores.
          </TableColText>
        </TableRow>

        {riskMap['Batida contra'] && montarControleExistencia('Batida contra')}
        {riskMap['Queda de mesmo nivel'] && montarControleExistencia('Queda de mesmo nivel')}
        {riskMap['Queda de diferente nível'] && montarControleExistencia('Queda de diferente nível')}
        {riskMap['Queda fiação aparente'] && montarControleExistencia('Queda fiação aparente')}
      </Table>
    </View>
  )
}

export default PgrTable
